import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangaData';

export default function CategoryGrid() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-100 font-heading">漫画分类</h2>
            <p className="text-sm text-foreground-500 mt-1">按题材浏览你喜欢的漫画</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 hover:bg-background-200 border border-background-300/60 hover:border-primary-500/50 rounded-lg p-4 md:p-5 text-center transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors duration-200">
                <i className="ri-bookmark-line text-lg md:text-xl text-primary-500"></i>
              </div>
              <p className="text-sm font-medium text-foreground-200 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {cat.name}
              </p>
              <p className="text-xs text-foreground-600 mt-1 line-clamp-1">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}